import React from "react";

const COPY =
  "The British Business Bank has officially launched the new £210 million South East Investment Fund. The fund will provide businesses across the South East with access to a range of finance options to support growth and investment, helping to address funding gaps in the region. We know there is exceptional entrepreneurial talent throughout the South East, and we look forward to working with founders and management teams, providing the finance they need to grow. By backing companies with strong potential, we can help create jobs, drive innovation and contribute to long-term economic growth throughout the South East.";

export const SouthEastFundTile = () => (
  <div
    className="group relative bg-white rounded-2xl p-5 sm:p-6 border border-[#E5E5E0] shadow-[0_20px_60px_-30px_rgba(5,47,36,0.4)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_28px_75px_-28px_rgba(5,47,36,0.55)]"
    data-testid="south-east-fund-tile"
  >
    <h2
      className="font-display font-extrabold tracking-tight leading-[1.05] text-xl sm:text-2xl"
      data-testid="south-east-fund-heading"
    >
      £210m <span className="inline-block bg-[#052F24] text-[#DFFF00] px-2 -rotate-1">South East Fund</span>
    </h2>

    <div className="relative mt-2.5">
      <p
        className="text-sm font-light text-[#052F24]/55 leading-relaxed max-h-[4.3rem] group-hover:max-h-[420px] overflow-hidden transition-[max-height] duration-500 ease-in-out"
        data-testid="south-east-fund-copy"
      >
        {COPY}
      </p>
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 h-7 bg-gradient-to-t from-white to-transparent transition-opacity duration-300 group-hover:opacity-0"
        data-testid="south-east-fund-fade"
      />
    </div>
  </div>
);
